import { render, staticRenderFns } from "./BaseRadioButtonGroup.vue?vue&type=template&id=3ec5d1a8&scoped=true&"
import script from "./BaseRadioButtonGroup.vue?vue&type=script&lang=js&"
export * from "./BaseRadioButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseRadioButtonGroup.vue?vue&type=style&index=0&id=3ec5d1a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec5d1a8",
  null
  
)

export default component.exports